import { formatBytes, isCDPTest } from '../../../utils/utilityFunctions';

import {
  convertToMilliseconds,
  convertTimeTaken,
} from '../../../utils/dateTimeUtils';

import {
  FETCH_NETWORK_LOGS_ERROR,
  FETCH_NETWORK_LOGS_SUCCESS,
  FETCH_NETWORK_LOGS_LOADING,
  FETCH_NETWORK_HAR_LOGS_LOADING,
  FETCH_NETWORK_HAR_LOGS_SUCCESS,
  FETCH_NETWORK_HAR_LOGS_ERROR,
  CLEAR_NETWORK_LOGS,
  SET_NETWORK_FULL_HAR_LOGS,
} from '../../actionTypeConstants/ml2.0/NetworkLogs';

import get from 'lodash/get';

const initialState = {
  isNetworkHarDataLoaded: false,
  networkFullHarData: {},
  data: [],
  loading: true,
  error: null,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_NETWORK_LOGS_LOADING: {
      return {
        ...state,
        loading: true,
        data: [],
        error: null,
      };
    }

    case FETCH_NETWORK_LOGS_SUCCESS: {
      const {
        areLogsFetchedFromLTMA = false,
        isAccurateVideoStartTimestampAvailable,
        isMobile,
        type,
        videoStartTimestamp,
      } = action.payload;

      const logList = areLogsFetchedFromLTMA
        ? isMobile
          ? get(action, ['result', 'data', 'log', 'entries'], [])
          : get(action, ['result', 'data'], [])
        : get(action, ['result', 'data', 'data'], []);
      let updatedLogList = [];
      logList.forEach((log, index) => {
        const isCDP = isCDPTest(type);
        const objToUse = log.Value || log; // log in case of mobile tests
        const requestStartedDatetime = objToUse.startedDateTime;
        const convertToNanosecondsMultiplier = isCDP || isMobile ? 1 : 1000000;
        const requestStartTimestamp =
          new Date(requestStartedDatetime).getTime() *
          convertToNanosecondsMultiplier; //To convert milliseconds to nanoseconds
        const areTimestampsInMilliseconds = isCDP || isMobile;
        const videoStartTime =
          (isCDP && isAccurateVideoStartTimestampAvailable) || isMobile
            ? Math.floor(videoStartTimestamp / 1000000)
            : videoStartTimestamp;
        const timestampToDisplay = isMobile
          ? null
          : convertToMilliseconds(
              requestStartTimestamp,
              videoStartTime,
              areTimestampsInMilliseconds, // areTimestampsInMilliseconds
              isAccurateVideoStartTimestampAvailable
            );
        const size = get(objToUse, ['response', 'bodySize'], 0);
        const formattedSize = formatBytes(size);
        log['timestamp'] = timestampToDisplay;
        log['name'] = get(objToUse, ['request', 'url'], '-');
        log['status'] = get(objToUse, ['response', 'status'], '-');
        log['method'] = get(objToUse, ['request', 'method'], '-');
        log['type'] = get(objToUse, ['response', 'content', 'mimeType'], '-');
        log['size'] = formattedSize;
        log['duration'] = convertTimeTaken(get(objToUse, ['time'], 0), true);
        updatedLogList.push(log);
      });
      return {
        ...state,
        loading: false,
        data: updatedLogList,
        error: null,
      };
    }

    case FETCH_NETWORK_LOGS_ERROR: {
      return {
        ...state,
        loading: false,
        data: [],
        error: action.error.response,
      };
    }

    case FETCH_NETWORK_HAR_LOGS_LOADING: {
      return {
        ...state,
        loading: true,
        data: [],
        error: null,
      };
    }

    case FETCH_NETWORK_HAR_LOGS_SUCCESS: {
      const { areLogsFetchedFromLTMA = false, automationLogsHost = '' } =
        action.payload;
      const logsList =
        areLogsFetchedFromLTMA || automationLogsHost
          ? get(action, ['result', 'data'], [])
          : get(action, ['result', 'data', 'data'], []);
      const pages = logsList?.log?.pages || [];
      const updatedLogsList = {
        log: {
          ...logsList?.log,
          pages,
        },
      };

      return {
        ...state,
        loading: false,
        data: updatedLogsList,
        error: null,
      };
    }

    case FETCH_NETWORK_HAR_LOGS_ERROR: {
      return {
        ...state,
        loading: false,
        data: [],
        error: action.error.response,
      };
    }

    case CLEAR_NETWORK_LOGS: {
      return {
        ...state,
        loading: false,
        data: [],
        error: null,
      };
    }

    case SET_NETWORK_FULL_HAR_LOGS: {
      return {
        ...state,
        ...action.result,
      };
    }

    default: {
      return state;
    }
  }
}
